import { render, staticRenderFns } from "./Drones.vue?vue&type=template&id=07fbcaf2"
import script from "./Drones.vue?vue&type=script&lang=js"
export * from "./Drones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports